import { autoinject, bindable } from 'aurelia-framework';

@autoinject()
export class TeilnahmeAnfordern {

}